// To force deploy, increment the following number: 9

// ======== UTIL FOR DEV MODE ========
// MUST BE IN THIS FILE!!!
// basically, in dev mode, react will output a lot of errors
// a lot of them are not interesting, let's filter them out
import { ConsoleErrorForDevMode } from '~/src/dash/utils/dev_warning_helpers';
const backupConsoleErr = console.error;
console.error = ConsoleErrorForDevMode(backupConsoleErr);
// ======== UTIL FOR DEV MODE ========

// Import current reseller config
import '~/src/dash/resellers/utils/importResellerConfig.ts';

import React from 'react';
import ReactDOM from 'react-dom';

import { AppView } from '~/src/dash/views/app-view';

// Render
ReactDOM.render(<AppView></AppView>, document.getElementById('app'));
